import * as FIELD_NAME from 'constant/form-item-names'
import * as RULES from 'constant/form-rules'
import * as NUMBER from 'constant/number'
import React from 'react'
import { Form, Input } from 'antd'
import PropTypes from 'prop-types'
import styles from '../styles.scss'

const NameInput = ({ disabled = false, name = FIELD_NAME.NAME, title = 'Name' }) => {
  return (
    <>
      <span>{title}</span>
      <Form.Item
        disabled={disabled}
        name={name}
        rules={[RULES.REQUIRED, RULES.maxCharLength(NUMBER.ONE_HUNDRED), name.includes('uuid') && RULES.UUID_VALIDITY]}
      >
        <Input
          className={styles.form_input}
          disabled={disabled}
          placeholder={title}
        />
      </Form.Item>
    </>
  )
}

NameInput.propTypes = {
  disabled: PropTypes.bool,
  name: PropTypes.string,
  title: PropTypes.string
}

export default NameInput
